<template>
  <label>
    <div class="gxxt-radio" :class="$slots.icon || $slots.default ? 'flex' : ''">
      <div v-if="!after">
        <span class="icon" v-if="$slots.icon">
          <slot name="icon"></slot>
        </span>
        <span class="label">
          <slot></slot>
        </span>
      </div>
      <div class="radio">
        <input
          :readonly="readonly"
          :value="label"
          :checked="value == label"
          :disabled="disabled"
          type="radio"
          :name="name"
          @change="change"
        />
        <span class="radio-icon">
          <i class="iconfont icon-duigou"></i>
        </span>
      </div>
      <div v-if="after">
        <span class="icon" v-if="$slots.icon">
          <slot name="icon"></slot>
        </span>
        <span class="label">
          <slot></slot>
        </span>
      </div>
    </div>
  </label>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    after: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'radio',
    },
    value: {
      type: [String, Number, Object, Boolean],
      default: '',
    },
    label: {
      type: [String, Number, Object, Boolean],
      default: '',
    }
  },
  emits: ['blur', 'focus', 'change', 'input', 'clear', 'update:modelValue'],
  data() {
    return {}
  },
  methods: {
    change(e) {
      this.$emit('change', e.target.value)
    },
  },
}
</script>

<style scoped lang="less">
label {
  display: inline-block;
  font-size: 0;
}
*{
  vertical-align: middle;
}
label .gxxt-radio {
  width: 100%;
}
.gxxt-radio {
  color: #333;
  font-size: 28px;
  display: inline-block;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.gxxt-radio .icon {
  font-size: 40px;
  margin-right: 16px;
}
.radio {
  position: relative;
  width: 36px;
  height: 36px;
  margin: 0 10px;
  input {
    border: none;
    outline: none;
  }
  input + .radio-icon {
    display: inline-block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #ddd;
    position: relative;
    i {
      position: absolute;
      color: #ddd;
      font-size: 20px;
      top: 56%;
      left: 54%;
      display: inline-block;
      transform: translate(-50%, -50%) scale(1);
    }
  }
  input:checked + .radio-icon {
    background: #f60;
    border: 1px solid #f60;
    i {
      color: #fff;
    }
  }
}
.radio input {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  opacity: 0;
}
</style>